<ng-container *ngIf="productList && productList.length > 0">
  <article
    class="card shadow-sm card-product-list"
    *ngFor="
      let item of productList
        | paginate : { itemsPerPage: 48, currentPage: p }
    "
  >
    <div class="row no-gutters">
      <aside class="col-md-3 p-2" (click)="viewProductDetail(item)">
        <a class="img-wrap">
          <img
            class="img-fluid card-img-top"
            src="{{ item.coverImage }}"
            alt="{{ item.product }}"
          />
        </a>
      </aside>
      <div class="col-md-6" (click)="viewProductDetail(item)">
        <div class="info-main">
          <h5 class="card-title">
            {{ item.product }}
          </h5>
          <p class="crop-text-2"><span [innerHTML]="getTruncatedDescription(item.description)"></span></p>
        </div>
      </div>
      <aside class="col-sm-3">
        <div class="info-aside">
          <div class="price-wrap">
            <span class="price h5"> {{ item.priceShop | currency }} </span>
              <del class="price-old" *ngIf="item.undiscountedPrice > item.priceShop">
                {{ item.undiscountedPrice | currency }}
              </del>
          </div>
          <br />
        </div>
      </aside>
    </div>
  </article>
</ng-container>
<div class="col-md-5 mx-auto my-4">
  <ng-container *ngIf="productList && productList.length > 0">
    <pagination-controls (pageChange)="pageChange.emit($event)"></pagination-controls>
  </ng-container>
</div>